export interface ReceivedLabels {
  order: string;
  ledger: string;
  orderShort: string;
  ledgerShort: string;
}

export interface TimeRangeLabels {
  today: ReceivedLabels;
  yesterday: ReceivedLabels;
  week: ReceivedLabels;
  month: ReceivedLabels;
}

export const DEFAULT_RECEIVED_LABELS: TimeRangeLabels = {
  today: {
    order: "Today's Order Received",
    ledger: "Outstanding Ledger Received",
    orderShort: "Today's Received",
    ledgerShort: "Outstanding Received"
  },
  yesterday: {
    order: "Yesterday's Order Received",
    ledger: "Yesterday's Ledger Received",
    orderShort: "Yesterday's Received",
    ledgerShort: "Outstanding Received"
  },
  week: {
    order: "This Week's Order Received",
    ledger: "This Week's Ledger Received",
    orderShort: "Weekly Received",
    ledgerShort: "Outstanding Received"
  },
  month: {
    order: "This Month's Order Received",
    ledger: "This Month's Ledger Received",
    orderShort: "Monthly Received",
    ledgerShort: "Outstanding Received"
  }
};

export const TIME_RANGE_LABELS = {
  today: "Today's",
  yesterday: "Yesterday's",
  week: "This Week's",
  month: "This Month's"
} as const;

export const PAYMENT_LABELS = {
  today: "Direct Payment",
  yesterday: "Direct Payment",
  week: "Weekly Payment",
  month: "Monthly Payment"
} as const;

export const SETTLEMENT_LABELS = {
  today: "Outstanding Settlement",
  yesterday: "Outstanding Settlement",
  week: "Outstanding Settlement",
  month: "Outstanding Settlement"
} as const;

export const NO_DATA_MESSAGES = {
  today: "No orders placed today",
  yesterday: "No orders placed yesterday",
  week: "No orders placed this week",
  month: "No orders placed this month"
} as const;

// Helper functions
export const getReceivedLabels = (timeRange: keyof TimeRangeLabels): ReceivedLabels => {
  return DEFAULT_RECEIVED_LABELS[timeRange] || DEFAULT_RECEIVED_LABELS.today;
};

export const getTimeRangeLabel = (range: keyof typeof TIME_RANGE_LABELS): string => {
  return TIME_RANGE_LABELS[range] || TIME_RANGE_LABELS.today;
};

export const getPaymentLabel = (range: keyof typeof PAYMENT_LABELS): string => {
  return PAYMENT_LABELS[range] || PAYMENT_LABELS.today;
};

export const getSettlementLabel = (range: keyof typeof SETTLEMENT_LABELS): string => {
  return SETTLEMENT_LABELS[range] || SETTLEMENT_LABELS.today;
};

export const getNoDataMessage = (range: keyof typeof NO_DATA_MESSAGES): string => {
  return NO_DATA_MESSAGES[range] || NO_DATA_MESSAGES.today;
};